import CONF from 'config/conf.singleton';
import H from 'constants/httpMethod.const';
import endpoint from 'utils/backend/endpoint.util';
import fromArrayToCommatose from 'utils/converters/string/fromArrayToCommatose.util';
import withOptions from 'utils/functions/withOptions.util';
import actionBe from 'utils/mw/actionBe.util';

const beCashupBreakdown = actionBe(
  'beCashupBreakdown',
  withOptions(({ AT, ATAG, begin, end, ids, group }) =>
    endpoint(H.get, `cashup/:salonId/bystylist/?end=:end&start=:begin&group=:group?&stylist_id=:ids?`, {
      base: CONF.transactionApiRoot,
      AT,
      name: ATAG,
      params: { begin, end, group, ids: fromArrayToCommatose(ids) || void 1 },
    }),
  ),
);

export default beCashupBreakdown;
